(function () {
  function norm(v) {
    return (v == null) ? "" : String(v).trim().replace(/\s+/g, " ");
  }
  function uniqSorted(arr) {
    return Array.from(new Set(arr.filter(Boolean).map(norm))).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    });
  }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === "class") n.className = attrs[k];
        else if (k === "html") n.innerHTML = attrs[k];
        else n.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      n.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return n;
  }

  var FILTER_FIELDS = [
    { key: "axle_dia", label: "Axle Dia" },
    { key: "style", label: "Style" },
    { key: "bolt_dia", label: "Bolt Dia" },
    { key: "length", label: "Length" },
    { key: "leafs", label: "# Leafs" },
    { key: "spring_width", label: "Spring Width" },
    { key: "thread_length", label: "Thread Length" }
  ];

  function rowMatches(row, state) {
    for (var i = 0; i < FILTER_FIELDS.length; i++) {
      var k = FILTER_FIELDS[i].key;
      if (state[k] && norm(row[k]) !== state[k]) return false;
    }
    return true;
  }
  function filterRows(rows, state) {
    return rows.filter(function (r) { return rowMatches(r, state); });
  }
  function buildOptions(rows, fieldKey, state) {
    var temp = {};
    Object.keys(state).forEach(function (k) { temp[k] = state[k]; });
    temp[fieldKey] = "";
    var narrowed = filterRows(rows, temp);
    return uniqSorted(narrowed.map(function (r) { return norm(r[fieldKey]); }));
  }

  function makeSelect(label) {
    var select = el("select", { class: "ubolt__select" }, [
      el("option", { value: "" }, ["All"])
    ]);
    var wrap = el("div", { class: "ubolt__field" }, [
      el("div", { class: "ubolt__label" }, [label]),
      select
    ]);
    return { wrap: wrap, select: select };
  }
  function setSelectOptions(select, options, keepValue) {
    var current = keepValue ? norm(select.value) : "";
    var normOptions = options.map(norm);

    select.innerHTML = "";
    select.appendChild(el("option", { value: "" }, ["All"]));
    normOptions.forEach(function (v) {
      select.appendChild(el("option", { value: v }, [v]));
    });

    if (keepValue && current && normOptions.indexOf(current) !== -1) select.value = current;
    else select.value = "";
  }

  function mount(container) {
    var dataUrl = container.getAttribute("data-ubolt-json") || "/assets/ubolt-data.json";

    // NOTE: we read it, but the search we build forces prefix=none for exactness.
    var searchPrefix = (container.getAttribute("data-search-prefix") || "none").trim(); // last|none
    var maxSkus = parseInt(container.getAttribute("data-max-skus") || "25", 10);
    if (!isFinite(maxSkus) || maxSkus < 1) maxSkus = 25;

    container.innerHTML = "";
    container.classList.add("ubolt");
    container.appendChild(el("div", { class: "ubolt__loading" }, ["Loading…"]));

    fetch(dataUrl, { cache: "no-store" })
      .then(function (r) {
        if (!r.ok) throw new Error("Failed to load " + dataUrl + " (" + r.status + ")");
        return r.json();
      })
      .then(function (rows) {
        var cleaned = (rows || []).map(function (r) {
          var o = {};
          Object.keys(r || {}).forEach(function (k) {
            o[k] = (k === "url") ? r[k] : norm(r[k]);
          });
          return o;
        });
        render(container, cleaned, { searchPrefix: searchPrefix, maxSkus: maxSkus });
      })
      .catch(function (err) {
        container.innerHTML = "";
        container.appendChild(el("div", { class: "ubolt__error" }, ["U-Bolt Finder error: " + err.message]));
      });
  }

  function render(container, rows, opts) {
    var state = {
      bolt_dia: "",
      axle_dia: "",
      style: "",
      length: "",
      leafs: "",
      spring_width: "",
      thread_length: ""
    };

    var selects = {};
    FILTER_FIELDS.forEach(function (f) {
      selects[f.key] = makeSelect(f.label);
    });

    var goBtn = el("button", { type: "button", class: "ubolt__go" }, ["Go"]);
    var clearBtn = el("button", { type: "button", class: "ubolt__clear" }, ["Clear"]);

    var style = el("style", {
      html: `
        .ubolt{border:1px solid rgba(0,0,0,.10); border-radius:12px; padding:14px; margin:0;}
        .ubolt__top{display:flex; flex-wrap:wrap; gap:var(--ubolt-gap, 10px); align-items:end;}
        .ubolt__field{display:flex; flex-direction:column; gap:6px; min-width:160px;}
        .ubolt__label{font-size:12px; opacity:.8;}
        .ubolt__select{padding:8px 10px; border:1px solid rgba(0,0,0,.18); border-radius:8px; background:#fff;}
        .ubolt__go,.ubolt__clear{padding:9px 14px; border-radius:8px; border:1px solid rgba(0,0,0,.18); background:#fff; cursor:pointer; min-width:92px;}
        .ubolt__loading,.ubolt__error{padding:10px;}
      `
    });

    function syncStateFromUI() {
      FILTER_FIELDS.forEach(function (f) {
        state[f.key] = norm(selects[f.key].select.value);
      });
    }

    function rebuildDropdowns(keepCurrent) {
      syncStateFromUI();
      FILTER_FIELDS.forEach(function (f) {
        var optsList = buildOptions(rows, f.key, state);
        setSelectOptions(selects[f.key].select, optsList, keepCurrent);
        state[f.key] = norm(selects[f.key].select.value);
      });
    }

    function clearAll() {
      FILTER_FIELDS.forEach(function (f) { selects[f.key].select.value = ""; });
      rebuildDropdowns(false);
    }

    function goToShopifySearch() {
      rebuildDropdowns(true);
      syncStateFromUI();

      var matches = filterRows(rows, state);
      if (!matches.length) {
        alert("No items match these selections. Try changing a filter.");
        return;
      }

      var skus = uniqSorted(matches.map(function (r) { return r.name; }));
      if (skus.length > opts.maxSkus) {
        alert("Too many matches (" + skus.length + "). Please narrow your selections, then click Go.");
        return;
      }

      // Quote each SKU for tighter matching
      var q = skus.map(function (s) {
        s = String(s).replace(/"/g, '\\"');
        return '"' + s + '"';
      }).join(" OR ");

      // Force SKU-field search only (reduces "similar items")
      var url = "/search"
        + "?q=" + encodeURIComponent(q)
        + "&type=product"
        + "&options[fields]=" + encodeURIComponent("variants.sku")
        + "&options[prefix]=none";

      window.location.href = url;
    }

    FILTER_FIELDS.forEach(function (f) {
      selects[f.key].select.addEventListener("change", function () {
        rebuildDropdowns(true); // dynamic/cascading options
      });
    });

    goBtn.addEventListener("click", goToShopifySearch);
    clearBtn.addEventListener("click", clearAll);

    var top = el("div", { class: "ubolt__top" }, []);
    FILTER_FIELDS.forEach(function (f) { top.appendChild(selects[f.key].wrap); });

    top.appendChild(el("div", { class: "ubolt__field" }, [el("div", { class: "ubolt__label" }, [" "]), goBtn]));
    top.appendChild(el("div", { class: "ubolt__field" }, [el("div", { class: "ubolt__label" }, [" "]), clearBtn]));

    container.innerHTML = "";
    container.appendChild(style);
    container.appendChild(top);

    rebuildDropdowns(false);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('[data-ubolt-lookup="1"]').forEach(mount);
  });
})();